import UserProfile from 'components/UserProfile'
import authPage from 'hocs/authPage'
import { VERBIAGE_LABEL } from 'utilities/constants';

export default authPage({title: [VERBIAGE_LABEL.PROFILE], offsets: 2})(UserProfile);
